import React from 'react';

export default function MarketingHowItWorks() {
    return (
        <div className="steps-section">
            <div className="steps-grid-bg"></div>
            <div className="steps-inner">
                <div className="eyebrow reveal" style={{ justifyContent: 'center' }}>
                    <div className="eyebrow-line" style={{ background: 'rgba(147,197,253,.5)' }}></div>
                    <span className="eyebrow-text">How it works</span>
                    <div className="eyebrow-line" style={{ background: 'rgba(147,197,253,.5)' }}></div>
                </div>
                <h2 className="section-title reveal reveal-delay-1">From question to<br /><em>clinical answer</em> in seconds</h2>
                <p className="section-sub reveal reveal-delay-2">Axon's three-stage pipeline ensures every response is grounded, structured, and traceable.</p>

                <div className="steps-row">
                    <div className="step reveal reveal-delay-1">
                        <div className="step-num-wrap"><div className="step-num">1</div></div>
                        <div className="step-title">Ask in natural language</div>
                        <div className="step-desc">Type any clinical question — a diagnosis, a protocol, a drug interaction. No special syntax required. Axon understands neurology.</div>
                    </div>
                    <div className="step reveal reveal-delay-2">
                        <div className="step-num-wrap"><div className="step-num">2</div></div>
                        <div className="step-title">Axon retrieves & synthesises</div>
                        <div className="step-desc">Axon searches the Neurochecklists knowledge base in real time — matching your query to the most relevant guidelines, criteria, and protocols.</div>
                    </div>
                    <div className="step reveal reveal-delay-3">
                        <div className="step-num-wrap"><div className="step-num">3</div></div>
                        <div className="step-title">Get a structured, cited answer</div>
                        <div className="step-desc">Receive a clean, checklist-formatted response with full source citations — ready to use, verify, or export to your research workflow.</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
